import { getActions, getReducers, getTypes } from '../initializers';

/**
 * Signed-in viewer's PointsLedger history, newest first.
 *
 * Paginates by growing `limit` rather than by cursor: the wallet renders exactly
 * what the last response held, so there is no client-side page accumulation to
 * get out of sync, and the backend only needs a Query limit.
 *
 * NOTE: the read endpoint does not exist yet. Phase 1 shipped the ledger writes
 * plus `GET /rngroyale/points/:streamerId/:username` (balance only) and
 * `GET /rngroyale/leaderboard/:streamerId`, and the PointsLedger table is keyed
 * `streamerId` + `${ts}#${txId}` with no viewerUsername index, so a per-viewer
 * read needs a GSI before it can be served. The wallet handles the 404 and shows
 * a "coming online" state until then; nothing else here needs to change.
 */
const identifier = 'POINTS_LEDGER';

export const getLedgerState = (state) => state.points?.ledger;

export const types = getTypes(identifier);
export const actions = getActions(
  identifier,
  (params) => `rngroyale/ledger/me?limit=${params.limit || 25}`
);
const reducer = getReducers(identifier);

export default reducer;
